import { useQuery } from "react-query";
import { hydraSearchToAppSearch } from "src/api/_common/hydra/search";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { GridProductSchema, productGridKey } from "../useGetAllproduct";
import { isQueryReady } from "src/api/axiosClient/utils";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";

export type Options = {
    companyId?: number;
    campaignId?: number;
    params?: AxiosParams;
    scoresQuery?: OlapScoresQuery;
};
export const useAutoSyncGetAllProducts = (options?: Options) => {
    const { companyId, campaignId, params = {}, scoresQuery } = options || {};

    const isEnabled = campaignId !== undefined;
    const paramsKey = JSON.stringify(params);

    const query = useQuery({
        queryKey: [productGridKey, paramsKey, companyId, campaignId, scoresQuery],
        staleTime: 0,
        cacheTime: 0, // Don't keep data in cache - force fresh fetch every time
        refetchOnMount: "always", // Always refetch when component mounts
        refetchOnWindowFocus: false, // Don't refetch on window focus
        keepPreviousData: false, // Don't keep previous data when query key changes
        enabled: isEnabled,
        queryFn: async () => {
            const url = `/api/products`;
            const request = await loggedInApiCall.get(url, {
                params: {
                    ...params,
                    organization_id: companyId,
                    campaign: campaignId,
                    ...scoresQuery,
                },
            });

            const totalItems = request.data["hydra:totalItems"];
            const rawProductGrid = request.data["hydra:member"];
            const appSearch = hydraSearchToAppSearch(request.data["hydra:search"]);
            const data = zodParseWithDetailedLog(rawProductGrid, GridProductSchema.array(), {
                operation: "GET",
                endpoint: "/products",
            });

            return {
                products: data,
                totalItems: totalItems,
                appSearch,
            };
        },
        onError: () => {
            return {
                products: [],
                totalItems: 0,
                appSearch: {},
            };
        },
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        ...query.data,
        isReady,
        ...query,
    };
};
